import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';

@Component({
  selector: 'm-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {

    constructor(public snackBarRef: MatSnackBar,
                @Inject(MAT_SNACK_BAR_DATA) public data: any) {
        console.log(data);
    }
}
